"use client";

import Layout from "./Layout.js";
import { useI18n } from "../lib/i18n.js";
import CasesGridItem from "./CasesGridItem.js";
import CustomerLogoCarousel from "./CustomerLogoCarousel.js";

export default function CasesIndex({ cases, customers }) {
  const { t } = useI18n();

  return (
    <Layout
      title={t("cases.title")}
      description={t("cases.text")}
      path="/cases"
      translationPath="/cases"
      shareImg={(cases && cases[0]?.gridImage) || null}
    >
      <div className="px-4 py-8 sm:px-8">
        <div className="mx-auto max-w-screen-md">
          <h1
            data-cy="pageMainTitle"
            className="mb-16 mt-8 text-center text-green"
          >
            {t("cases.header")}
          </h1>
          <p className="text-center">{t("cases.description")}</p>
        </div>
        <div className="container mx-auto grid grid-cols-1 gap-8 py-16 md:grid-cols-2 max-w-screen-lg">
          {cases.map((caseItem) => {
            return <CasesGridItem key={caseItem.slug} {...caseItem} />;
          })}
        </div>
      </div>
      <CustomerLogoCarousel customers={customers} />
    </Layout>
  );
}
